import { utils } from "sw-hic";
import x2js from "x2js";

// 控件类型
export const eTypes = [
  { code: 1, text: "文本框" },
  { code: 2, text: "数字框" },
  { code: 3, text: "单选框" },
  { code: 4, text: "多选框" },
  { code: 5, text: "单选文本框" },
  { code: 6, text: "多选文本框" },
  { code: 7, text: "日期框" },
  { code: 8, text: "选择框" },
  { code: 9, text: "数据组" },
  { code: 10, text: "病历段" },
  { code: 11, text: "表格" },
];
// 属性对照
export const eProps = [
  { code: "dataName", text: "名称", type: "lb", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  { code: "type", text: "类型", type: "lb", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  { code: "HelpTip", text: "提示信息", type: "str", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "PlaceHolder", text: "占位符", type: "str", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "getRes", text: "数据绑定", type: "data", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] },
  { code: "cols", text: "列", type: "str", eleType: [11], hide: true },
  { code: "DeleteProtect", text: "禁止删除", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "EditProtect", text: "禁止编辑", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "IsCtrlHidden", text: "隐藏", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "ReverseEdit", text: "反向编辑", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "BackgroundColor", text: "背景色", type: "str", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "Printable", text: "允许打印输出", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "MustFillContent", text: "必填项", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "ViewSecret", text: "掩码显示", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "IsNotRecordInXML", text: "允许XML输出", type: "bool", eleType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
  { code: "TextBoxMaxLen", text: "最大长度", type: "num", eleType: [1] },
  { code: "TextBoxMinLen", text: "最小长度", type: "num", eleType: [1] },
  { code: "MaxValue", text: "最大值", type: "num", eleType: [2] },
  { code: "MinValue", text: "最小值", type: "num", eleType: [2] },
  { code: "Unit", text: "单位", type: "str", eleType: [2] },
  { code: "Precision", text: "精度", type: "str", eleType: [2] },
  { code: "OutRangeInfo", text: "超出时异常文本", type: "str", eleType: [2] },
  { code: "ContentException", text: "其他异常文本", type: "str", eleType: [2] },
  { code: "CheckOption", text: "提示文本", type: "str", eleType: [8] },
  { code: "IsChecked", text: "选中", type: "bool", eleType: [8] },
  {
    code: "CheckPos",
    text: "文本位置",
    type: "opt",
    eleType: [8],
    opts: [
      { code: "LEFT", text: "左" },
      { code: "LEFT", text: "右" },
    ],
  },
  { code: "StartDateTime", text: "起始日期", type: "dt", eleType: [7] },
  { code: "EndDateTime", text: "截止日期", type: "dt", eleType: [7] },
  {
    code: "Style",
    text: "格式",
    type: "opt",
    eleType: [7],
    opts: [
      { code: 0, text: "YYYY-MM-DD HH:MM" },
      { code: 1, text: "YYYY-MM-DD HH" },
      { code: 2, text: "YYYY-MM-DD" },
      { code: 3, text: "MM-DD" },
      { code: 4, text: "HH:MM" },
      { code: 5, text: "YYYY年M月D日HH时MM分" },
      { code: 6, text: "YYYY年M月D日HH时" },
      { code: 7, text: "YYYY年M月D日" },
      { code: 8, text: "M月D日" },
      { code: 9, text: "HH时MM分" },
      { code: 10, text: "YYYY/M/D" },
      { code: 11, text: "YYYY-MM-DD 星期" },
      { code: 12, text: "YYYY-MM-DD 星期 HH:MM" },
      { code: 13, text: "MM-DD 星期" },
      { code: 14, text: "YYYY年M月D日 星期 HH时MM分" },
      { code: 15, text: "YYYY年M月D日 星期 HH时" },
      { code: 16, text: "YYYY年M月D日 星期" },
      { code: 17, text: "M月D日 星期" },
      { code: 18, text: "YYYY/M/D 星期" },
      { code: 19, text: "YYYY-MM-DD (星期) HH:MM:SS" },
    ],
  },
  { code: "Code", text: "默认编码", type: "str", eleType: [3, 4, 5, 6] },
  { code: "ShowValue", text: "显示值", type: "bool", eleType: [3, 4, 5, 6] },
  { code: "metaData", text: "元数据", type: "obj", eleType: [10], hide: true },
  { code: "loaded", text: "是否已加载", type: "bool", eleType: [10], hide: true },
  { code: "isClone", text: "是否是生成的", type: "bool", eleType: [10], hide: true },
];

const editorUtils = {
  // 是否存在
  isKnown(val) {
    return val && val != "UnKnown";
  },
  // 是否是选择控件
  isSelectControl(type) {
    switch (type) {
      case "单选框":
      case "多选框":
      case "单选组合框":
      case "多选组合框 ":
        return true;
        break;
      default:
        return false;
    }
  },
  // 从编辑器中获取元素
  getEle($editor, name, needAllProps) {
    let oRet = $editor.GetObjectType(name);
    switch (oRet.objectType) {
      case "数据元":
      case "文本框":
      case "数值框":
      case "单选框":
      case "多选框":
      case "单选组合框":
      case "多选组合框 ":
      case "日期框":
      case "复选框":
        oRet = $editor.GetNewControlProperty(name, ["type"]);
        oRet = $editor.GetNewControlProperty(name, needAllProps ? eProps.map((p) => p.code) : this.getPropCodes(oRet.props.type));
        break;
      case "区域":
      case "病历段":
        oRet = $editor.GetRegionProperty(name, needAllProps ? eProps.map((p) => p.code) : this.getPropCodes("病历段"));
        break;
      case "数据组":
        oRet = $editor.GetSectionProperty(name, needAllProps ? eProps.map((p) => p.code) : this.getPropCodes(oRet.objectType));
        break;
      case "表格":
        oRet = $editor.GetTableProperty(name, needAllProps ? eProps.map((p) => p.code) : this.getPropCodes(oRet.objectType));
        break;
      default:
        return null;
        break;
    }
    if (oRet.props) {
      oRet.props.name = name;
    }
    return oRet.props;
  },
  // 从编辑器中获取元素的父元素
  getEleParent($editor, name, needAllProps) {
    let oRet = $editor.GetFatherStructName(name);
    if (oRet.fatherStructName) {
      return this.getEle($editor, oRet.fatherStructName, needAllProps);
    }
    return null;
  },
  // 生成编辑器实例
  createDomEditor($editor, refObj) {
    let div = document.createElement("div");
    div.id = `editor${Math.floor(Math.random() * 1000)}`;
    refObj.$el.innerHTML = "";
    refObj.$el.appendChild(div);
    return $editor.CreateControl(div.id);
  },
  // 删除编辑器实例
  removeDomEditor($editor, refObj) {
    $editor.CloseEditor();
    refObj.$el.innerHTML = "";
  },
  eleTreeProp: {
    expandTrigger: "hover",
    label: "text",
    value: "code",
    children: "props",
  },
  eleIcon(prop) {
    if (prop.type == "obj") {
      return "el-icon-house";
    }
    if (prop.type == "list") {
      return "el-icon-files";
    }
    if (prop.type == "str") {
      return "el-icon-edit-outline";
    }
    if (prop.type == "dt") {
      return "el-icon-time";
    }
    if (prop.type == "num") {
      return "el-icon-c-scale-to-original";
    }
    if (prop.type == "dict") {
      return "el-icon-wallet";
    }
    return "el-icon-collection-tag";
  },
  getTypeCode(typeName) {
    let type = eTypes.find((t) => t.text == typeName);
    if (type) {
      return type.code;
    }
    return null;
  },
  // getPropName(code) {
  //     let type = eProps.find(t=> t.code == code)
  //     if (type) {
  //         return type.text
  //     }
  //     return null
  // },
  // 获取元素类型关联的属性数组
  getProps(typeName) {
    let code = this.getTypeCode(typeName);
    return eProps.filter((p) => p.eleType.findIndex((t) => t == code) >= 0);
  },
  // 获取元素类型关联的属性编码数组
  getPropCodes(typeName) {
    let code = this.getTypeCode(typeName);
    if (!code) {
      code = typeName;
    }
    return eProps.filter((p) => p.eleType.findIndex((t) => t == code) >= 0).map((p) => p.code);
  },
  // 从现有属性中过滤出元素类型可用属性数组
  getValidProps(typeName, propsObj, name) {
    let all = this.getProps(typeName);
    let props = [];
    Object.keys(propsObj).forEach((k) => {
      let prop = all.find((p) => p.code == k);
      prop.value = "UnKnown" == propsObj[k] ? null : propsObj[k];
      props.push(prop);
    });
    return props;
  },
  getEleFromXml(xml) {
    let ms = xml.match(/<NewCtrl.*?\/NewCtrl>/g);
    if (!ms) {
      return [];
    }
    let eles = ms.map((m) => {
      let ele = {};
      ele.id = /Id="(.*?)"/.exec(m)[1];
      ele.name = /Name="(.*?)"/.exec(m)[1];
      ele.type = /Type="(.*?)"/.exec(m)[1];
      ele.typeName = /TypeName="(.*?)"/.exec(m)[1];
      try {
        ele.getRes = /getRes="(.*?)"/.exec(m)[1];
      } catch (error) {
        ele.getRes = "";
      }

      return ele;
    });
    // console.log("eles==", JSON.stringify(eles))
    return eles;
  },
  getTableFromXml(xml) {
    let ms = xml.match(/<CTable .*?>/g);
    if (!ms) {
      return [];
    }
    let tbs = ms.map((m) => {
      let tb = {};
      tb.id = /Id="(.*?)"/.exec(m)[1];
      return tb;
    });
    return tbs;
  },
  dataType2EleType(dataType) {
    switch (dataType) {
      case "dt":
        return "日期框";
      case "list":
        return "表格";
      case "dict":
      case "enum":
        return "单选框";
      case "num":
        return "数字框";
      default:
        return "文本框";
    }
  },
  /**
   *
   * @param {*} node element tree组件的节点对象
   * @returns 元素数据对象
   */

  structTree2Ele(node) {
    let data = node.data;
    let ele = {
      name: data.text,
      type: this.dataType2EleType(data.type),
      label: data.text,
      PlaceHolder: `请输入${data.text}`,
    };

    if (data.type == "dict" || data.type == "enum" || data.type == "dt") {
      ele.PlaceHolder = `请选择${data.text}`;
    }

    let arr = [];

    function recurve(node) {
      if (node.level) {
        arr.push(node.data.code);
      } else {
        return;
      }
      recurve(node.parent);
    }

    recurve(node);

    ele.getRes = arr.reverse().join(".");

    switch (data.type) {
      case "dict":
        ele.dictType = data.dict;
        break;
      case "enum":
        ele.dictType = "enum." + data.enum;
        break;
      case "list":
        ele.cols = JSON.stringify(data.item.props.map((p) => ({ name: p.text, field: p.code })));
        break;
      default:
        break;
    }

    return ele;
  },
  getDeepValue(obj, path) {
    if (!this.isKnown(path)) {
      return null;
    }
    if (path == ".") {
      return obj;
    }
    let parts = path.split(".");
    let rp = obj;
    parts.forEach((p) => {
      if (rp) {
        rp = rp[p];
      }
    });
    return rp;
  },
  getBranch(tree, path) {
    if (!this.isKnown(path)) {
      return tree;
    }
    let parts = path.split(".");
    let rp = tree;
    parts.forEach((p) => {
      if (!Array.isArray(rp)) {
        rp = rp.props;
      }
      rp = rp.find((c) => c.code == p);
    });
    if (rp.type == "list") {
      let props = JSON.parse(JSON.stringify(rp.item.props));
      props.unshift({ code: "idx", text: "自动序号", type: "num" });
      return props;
    } else if (rp.type == "obj") {
      return rp.props;
    } else {
      return [];
    }
  },
  downloadBin(base64, filename) {
    let bytes = _base64ToUint8Array(base64);
    let blob = new Blob([bytes], { type: "application/octet-binary" });
    if ("msSaveOrOpenBlob" in navigator) {
      //IE EDGE
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      //CHROME FIREFOX
      let urlObject = window.URL || window.webkitURL || window;
      let save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
      save_link.href = urlObject.createObjectURL(blob);
      save_link.download = filename;
      document.body.appendChild(save_link);
      let ev = document.createEvent("MouseEvents");
      ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      save_link.dispatchEvent(ev);
      document.body.removeChild(save_link);
    }
  },
  downloadHtml(txt, filename) {
    let urlObject = window.URL || window.webkitURL || window;
    let export_blob = new Blob([txt], { type: "text/plain" });
    if ("msSaveOrOpenBlob" in navigator) {
      //IE EDGE
      window.navigator.msSaveOrOpenBlob(export_blob, filename);
    } else {
      //CHROME FIREFOX
      let save_link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = filename;
      document.body.appendChild(save_link);
      let ev = document.createEvent("MouseEvents");
      ev.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      save_link.dispatchEvent(ev);
      document.body.removeChild(save_link);
    }
  },
};
export default editorUtils;

function genStructData($editor, main, mr, ver) {
  let docStruct = {};

  let res = $editor.GetStructsXmlInfoByParament(1, true, true, "dataName", "dataName", "dataName");
  if (res.structsXml) {
    let doc = new x2js().xml2js(res.structsXml).Root.DocObjContent;
    utils.log("编辑器原始数据", doc);
    genStruct(doc, docStruct);
    utils.log("整理后结构化数据", docStruct);
  }
  let ret = $editor.GetTextFromDocument();
  docStruct.allText = ret.Text;
  docStruct.dbVer = "1"; // 重要，使用版本号区别旧版数据
  if (main) {
    docStruct.mainId = main.id || "";
    docStruct.patientCode = main.patientCode || "";
    docStruct.patientName = main.patientName || "";
    docStruct.opNo = main.opNo || "";
    docStruct.deptCode = main.deptCode || "";
    docStruct.deptName = utils.Dict.text(main.deptCode || "", "Dept");
  }
  if (mr) {
    docStruct.mrId = mr.id || "";
    docStruct.tmplCode = mr.tmplCode || "";
    docStruct.tmplName = mr.tmplName || "";
  }
  if (ver) {
    docStruct.verId = ver.id || "";
  }
  return docStruct;
}

function genStruct(obj, target) {
  if (Array.isArray(obj)) {
    obj.forEach((o) => {
      genStruct(o, target);
    });
    return;
  }
  if (obj.Content_Text) {
    if (typeof obj.Content_Text == "string") {
      target.其它补充 = obj.Content_Text;
    } else if (typeof obj.Content_Text == "object" && obj.Content_Text.__text) {
      target.其它补充 = obj.Content_Text.__text;
    }
  }
  Object.keys(obj).forEach((k) => {
    let ele = obj[k];
    let name = "";

    if (k == "Section" || k == "Region") {
      if (Array.isArray(ele)) {
        ele.forEach((e) => {
          name = e._dataName || e._Name;
          if (target[name]) {
            if (!Array.isArray(target[name])) {
              target[name] = [target[name]];
            }
            let prop = {};
            target[name].push(prop);
            genStruct(e, prop);
          } else {
            target[name] = {};
            genStruct(e, target[name]);
          }
        });
      } else {
        name = ele._dataName || ele._Name;
        target[name] = {};
        genStruct(ele, target[name]);
      }
    } else if (k == "NewCtrl") {
      if (Array.isArray(ele)) {
        ele.forEach((e) => {
          name = e._dataName || e._Name;
          target[name] = e.ParaRun.Text;
        });
      } else {
        name = ele._dataName || ele._Name;
        target[name] = ele.ParaRun.Text;
      }
    } else if (typeof ele === "object") {
      genStruct(ele, target);
    }
  });
}
export { genStructData };
